import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Button, IconButton, MenuItem } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useParams } from "react-router";
import Grid from "@mui/material/Grid2";
import { defaultVariables } from "../../../../../config";
import { useTranslation } from "react-i18next";
import { Alert, LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../../config/design/styles";
import { connect } from "trim-redux";
import SubTitle from "../../../../components/elements/SubTitle";
import Title from "../../../../components/elements/Title";
import { BadgeInfo,Copy } from "lucide-react";
import RayaField from "../../../../components/elements/fields/RayaField";

const VendorHours = (props) => {
    const { t } = useTranslation();

    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const [hours, setHours] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const navigation = useNavigate();

    let { id } = useParams();
    if (!id && !props.create) {
        if (!!props.user.shop) {
            id = props.user.shop.id;
        } else {
            navigation('/')
        }
    }
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };
    const loadData = () =>{
        axios
            .get(`${defaultVariables.url}/shops/hours/${id}`, config)
            .then((response) => setHours(formatHours(response.data)))
            .catch((error) => console.error(error));
    }
    useEffect(() => {
        loadData();
    }, [id]);

    const formatHours = (data) => {
        const initialHours = daysOfWeek.map((day) => ({
            day_of_week: day,
            slots: [{ open_time: { hours: null, minutes: null }, close_time: { hours: null, minutes: null } }]
        }));

        data.forEach((item) => {
            const dayIndex = initialHours.findIndex((day) => day.day_of_week === item.day_of_week);
            if (!initialHours[dayIndex].slots[item.slot_number - 1]) {
                initialHours[dayIndex].slots[item.slot_number - 1] = { open_time: { hours: null, minutes: null }, close_time: { hours: null, minutes: null } };
            }
            initialHours[dayIndex].slots[item.slot_number - 1] = {
                open_time: { hours: parseInt(item.open_time.split(':')[0]), minutes: parseInt(item.open_time.split(':')[1]) } || null,
                close_time: { hours: parseInt(item.close_time.split(':')[0]), minutes: parseInt(item.close_time.split(':')[1]) } || null
            };
        });

        return initialHours;
    };

    const handleInputChange = (dayIndex, slotIndex, field, type, value) => {
        setHours((prev) =>
            prev.map((day, index) =>
                index === dayIndex
                    ? {
                        ...day,
                        slots: day.slots.map((slot, sIndex) =>
                            sIndex === slotIndex ? { ...slot, [field]: { ...slot[field], [type]: value } } : slot
                        )
                    }
                    : day
            )
        );
    };

    const addSlot = (dayIndex) => {
        setHours((prev) =>
            prev.map((day, index) =>
                index === dayIndex && day.slots.length < 3 // Allow adding only if slots are less than 3
                    ? { ...day, slots: [...day.slots, { open_time: { hours: 0, minutes: 0 }, close_time: { hours: 0, minutes: 0 } }] }
                    : day
            )
        );
    };

    const removeSlot = (dayIndex, slotIndex) => {
        setHours((prev) =>
            prev.map((day, index) =>
                index === dayIndex
                    ? { ...day, slots: day.slots.filter((_, sIndex) => sIndex !== slotIndex) }
                    : day
            )
        );
    };

    const handleSubmit = () => {
        setSubmitLoading(true);

        // Construct the payload and handle null minutes as 0
        const payload = hours.map((day) => ({
            day_of_week: day.day_of_week,
            slots: day.slots
                .filter((slot) => {
                    // Check if both open_time and close_time have valid hours and treat null minutes as 0
                    const isOpenTimeValid = slot.open_time && slot.open_time.hours !== null;
                    const isCloseTimeValid = slot.close_time && slot.close_time.hours !== null;
                    return isOpenTimeValid && isCloseTimeValid;
                })
                .map((slot) => ({
                    open_time: `${String(slot.open_time.hours).padStart(2, '0')}:${String(slot.open_time.minutes || 0).padStart(2, '0')}`,
                    close_time: `${String(slot.close_time.hours).padStart(2, '0')}:${String(slot.close_time.minutes || 0).padStart(2, '0')}`
                }))
        }));

        // Check if any day has valid slots
        const hasValidSlots = payload.some((day) => day.slots.length > 0);

        /*if (!hasValidSlots) {
            enqueueSnackbar(t('pleaseReCheckTimeFields'), { variant: 'warning' });
            setSubmitLoading(false);
            return;
        }*/

        axios
            .post(`${defaultVariables.url}/shops/hours/${id}`, { hours: payload }, config)
            .then(() => {
                setSubmitLoading(false);
                enqueueSnackbar(t('detailsSet'), { variant: 'success' });
                loadData();
                let from_app = !!localStorage.getItem('from_app');
                if(!!from_app){
                    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'FORM_SUBMITTED' }));
                    }
                }
            })
            .catch((error) => {
                console.error(error);
                enqueueSnackbar(t('pleaseReCheckTimeFields'), { variant: 'warning' });
                setSubmitLoading(false);
            });
    };
    const copyFromPreviousDay = (dayIndex) => {
        if (dayIndex > 0) {
            setHours((prev) => {
                const updatedHours = [...prev];
                updatedHours[dayIndex].slots = [...prev[dayIndex - 1].slots];
                return updatedHours;
            });
        }
    };


    return (
        <Grid container spacing={2}>
            {
                !props.isApp &&
                <Grid item size={12}>
                    <Title align="left" color="text">{t('shopHours')}</Title>
                </Grid>
            }
            <Grid item size={12}>
                <Alert severity="success" icon={<BadgeInfo className="lucide-large" />}>
                    {t('chooseWorkingHoursOfYourShop')}
                </Alert>
            </Grid>
            <Grid item size={12}>
                {daysOfWeek.map((day, dayIndex) => (
                    <Box key={day} mb={3}>
                        <SubTitle style={{ marginBottom: 10, fontWeight:"700",  fontSize:14 }} align="left">
                            {day}
                            {dayIndex > 0 && (
                                <Button
                                    size="small"
                                    color="default"
                                    startIcon={<Copy className="lucide-small"/>}
                                    style={{ marginLeft: 8 , fontSize:13 }}
                                    onClick={() => copyFromPreviousDay(dayIndex)}
                                >
                                    {t("copyFromPreviousDay")}
                                </Button>
                            )}
                        </SubTitle>
                        {hours[dayIndex]?.slots.map((slot, slotIndex) => (
                            <Grid container spacing={2} key={slotIndex} alignItems="center" mb={2} className="position-relative mb-30">
                                <Grid item size={6}>
                                    <Grid container spacing={1} className="time-chooser-holder">
                                        <Grid item size={12}>
                                            <SubTitle align="left">{t('openTime')}</SubTitle>
                                        </Grid>
                                        <Grid item size={{xs:12,sm:6}}>
                                            <RayaField
                                                label={t('hours')}
                                                value={slot.open_time.hours !== null ? slot.open_time.hours : ""}
                                                onChange={(e) => handleInputChange(dayIndex, slotIndex, "open_time", "hours", e.target.value)}
                                                select
                                                fullWidth
                                                slotProps={{
                                                    select:{
                                                        MenuProps:{
                                                            PaperProps: {
                                                                style: {
                                                                maxHeight: 210,
                                                                overflowY: 'auto' ,
                                                                paddingTop:5,
                                                                }
                                                            }
                                                        }
                                                    }
                                                }}

                                            >
                                                {Array.from({ length: 24 }, (_, i) => (
                                                    <MenuItem key={i} value={i}>{String(i).padStart(2, '0')}</MenuItem>
                                                ))}
                                            </RayaField>
                                        </Grid>
                                        <Grid item size={{xs:12,sm:6}}>
                                            <RayaField
                                                label={t('minutes')}
                                                value={slot.open_time.minutes !== null ? slot.open_time.minutes : ""}
                                                onChange={(e) => handleInputChange(dayIndex, slotIndex, "open_time", "minutes", e.target.value)}
                                                select
                                                fullWidth
                                            >
                                                {[0, 15, 30, 45, 59].map((minute) => (
                                                    <MenuItem key={minute} value={minute}>{String(minute).padStart(2, '0')}</MenuItem>
                                                ))}
                                            </RayaField>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item size={6}>
                                    <Grid container spacing={1} className="time-chooser-holder">
                                        <Grid item size={12}>
                                            <SubTitle align="left">{t('closeTime')}</SubTitle>
                                        </Grid>
                                        <Grid item size={{xs:12,sm:6}}>
                                            <RayaField
                                                label={t('hours')}
                                                value={slot.close_time.hours !== null ? slot.close_time.hours : ""}
                                                onChange={(e) => handleInputChange(dayIndex, slotIndex, "close_time", "hours", e.target.value)}
                                                select
                                                fullWidth
                                                slotProps={{
                                                    select:{
                                                        MenuProps:{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 210,
                                                                    overflowY: 'auto' ,
                                                                    paddingTop:5,
                                                                }
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                {Array.from({ length: 24 }, (_, i) => (
                                                    <MenuItem key={i} value={i}>{String(i).padStart(2, '0')}</MenuItem>
                                                ))}
                                            </RayaField>
                                        </Grid>
                                        <Grid item size={{xs:12,sm:6}}>
                                            <RayaField
                                                label={t('minutes')}
                                                value={slot.close_time.minutes !== null ? slot.close_time.minutes : ""}
                                                onChange={(e) => handleInputChange(dayIndex, slotIndex, "close_time", "minutes", e.target.value)}
                                                select
                                                fullWidth
                                            >
                                                {[0, 15, 30, 45, 59].map((minute) => (
                                                    <MenuItem key={minute} value={minute}>{String(minute).padStart(2, '0')}</MenuItem>
                                                ))}
                                            </RayaField>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Box className="delete-hour">
                                    <IconButton color="error" onClick={() => removeSlot(dayIndex, slotIndex)}>
                                        <Delete />
                                    </IconButton>
                                </Box>
                            </Grid>
                        ))}
                        <Button
                            variant="outlined"
                            size="small"
                            color="secondary"
                            startIcon={<Add />}
                            disabled={hours[dayIndex]?.slots.length >= 3}
                            onClick={() => addSlot(dayIndex)}
                        >
                            {t('addSlot')}
                        </Button>
                    </Box>
                ))}
            </Grid>
            <Grid item size={12} style={{ textAlign: "center" }}>
                <LoadingButton
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>
        </Grid>
    );
};
const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    isApp: state.isApp,
});

export default withStyles(Styles)(connect(mstp)(VendorHours));